// extracted by mini-css-extract-plugin
export default {"welcomeSection":"DomyWelcome_welcomeSection__H5fjW","welcomeVideo":"DomyWelcome_welcomeVideo__bcJPt"};